/**
 * Component: Product Colors Swatches
 * ------------------------------------------------------------------------------
 * Generates the color swatches based on the product handle and color tag.
 *
 * @namespace productSwatchesColors
 */
import axios from 'axios';
import removeAccents from 'remove-accents';
import {on} from '../helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  quickviewContainer: '[js-quick-view="viewport"]',
  container: '[js-swatches-colors="container"]',
  colorName: '[js-swatches-colors="color-name"]',
};

/**
 * Create a new productSwatchesColors object.
 */
export default (swatchContainer) => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: (swatchContainer === 'quickView')
      ? document.querySelector(selectors.quickviewContainer).querySelector(selectors.container)
      : document.querySelector(selectors.container),
    colorName: document.querySelector(selectors.colorName),
  };

  /**
   * Build the query for GraphQL from the product handle
   */
  function buildQuery() {
    const cleanHandle = nodeSelectors.container.dataset.handle;
    return `{ products(first:50, query:"${cleanHandle}*") { edges { node { id title handle tags productType variants(first:1) { edges { node { image { src } sku } } } } } } }`;
  }

  /**
   * GraphQL call for the products
   */
  function graphQlCall() {
    axios({
      url: '/api/2019-07/graphql.json',
      method: 'post',
      data: {
        query: buildQuery(),
      },
      headers: {
        'X-Shopify-Storefront-Access-Token': window.theme.token,
      },
    }).then((result) => {
      const blocks = generateBlocks(result.data.data);
      nodeSelectors.container.innerHTML = blocks;
    }).then(()=>{
      handleListenerToColors()
    })
  }

  /**
   * Add listener to open more colors
   */
  
  function handleListenerToColors(){
    const swatchesContainer = nodeSelectors.container.querySelector('.js-color-swatches__container');
    const btnOpenModal = nodeSelectors.container.querySelector('.js-color-swatches__btn-open');
    const btnCloseModal = nodeSelectors.container.querySelector('.js-color-swatches__btn-close');
    const swatchesOverlay = nodeSelectors.container.querySelector('.js-color-swatches__overlay');

    btnOpenModal?.addEventListener('click', () => {
      swatchesContainer?.classList.add('is-active');
      document.body.style.overflow = "hidden";
    });
    btnCloseModal?.addEventListener('click', () => {
      swatchesContainer?.classList.remove('is-active');
      document.body.style.overflow ="";
    });
    swatchesOverlay?.addEventListener('click', () => {
      swatchesContainer?.classList.remove('is-active');
      document.body.style.overflow ="";
    });
  }

  /**
   * Generate the HTML code for the list of color variants
   * @param {Object} data - Axios call response
   */
  function generateBlocks(data) {
    let block = '';
    let indexer = 0;
    let restSwatchesContainer =
      document.querySelector('.t-color-swatches').innerHTML;
    let restSwatchesItems = ``;
    const assetsUrl = generateAssetsUrl();
    let currentSku = nodeSelectors.container.dataset.currentSku;


    data.products.edges.forEach(function (element, index) {
        if (!element.node.variants.edges[0].node.sku.includes(currentSku))
          return;
        const color = element.node.tags
            .find(function (e) {
              return e.includes('parent_colour: ');
            })
            .replace('parent_colour: ', '')
            .toLowerCase()

        if(color === nodeSelectors.container.dataset.currentColor) {
          nodeSelectors.colorName.innerHTML = color;

          block +=`<div class="swatch product-swatches-colors__swatch product-swatches-colors__swatch--active ">
                  <span class="product-swatches-colors__item product-swatches-colors__item--active swatch__button swatch-grid__item swatch"
                        data-color="${color}"
                        style="background-image:url('${element.node.variants.edges[0].node.image.src}');">
                    ${color}
                  </span>
                  <span class="product-swatches-colors__title">${color}</span>
                </div>`;
          indexer++;
        }
      }
    );

    data.products.edges.forEach(function (element, index) {
      if (!element.node.variants.edges[0].node.sku.includes(currentSku))
        return;
      const color = element.node.tags
          .find(function (e) {
            return e.includes('parent_colour: ');
          })
          .replace('parent_colour: ', '')
          .toLowerCase()
       
      if(color === nodeSelectors.container.dataset.currentColor) return;

      // PLEASE DO NOT DELETE  
      // WE MAY USE IT IN THE FUTURE
      // if (indexer <= 2) {
      //   block +=
      //   color === nodeSelectors.container.dataset.currentColor
      //       ? ``
      //       : `<div class="swatch product-swatches-colors__swatch">
      //           <a href="/products/${element.node.handle}"
      //               class="product-swatches-colors__item swatch__button swatch-grid__item swatch"
      //               data-color="${color}"
      //               style="background-image:url('${element.node.variants.edges[0].node.image.src}');">
      //             ${color}
      //           </a>
      //           <a href="/products/${element.node.handle}" class="product-swatches-colors__title">${color}</a>
      //         </div>`;
      // } else {
      //   restSwatchesItems +=
      //   color === nodeSelectors.container.dataset.currentColor
      //       ? ``
      //       : `<div class="swatch product-swatches-colors__swatch">
      //           <a href="/products/${element.node.handle}"
      //               class="product-swatches-colors__item swatch__button swatch-grid__item swatch"
      //               data-color="${color}"
      //               style="background-image:url('${element.node.variants.edges[0].node.image.src}');">
      //             ${color}
      //           </a>
      //           <a href="/products/${element.node.handle}" class="product-swatches-colors__title">${color}</a>
      //         </div>`;
      // }
      restSwatchesItems +=
        color === nodeSelectors.container.dataset.currentColor
            ? ``
            : `<div class="swatch product-swatches-colors__swatch">
                <a href="${window.Shopify.routes.root}products/${element.node.handle}"
                    class="product-swatches-colors__item swatch__button swatch-grid__item swatch"
                    data-color="${color}"
                    style="background-image:url('${element.node.variants.edges[0].node.image.src}');">
                  ${color}
                </a>
                <a href="${window.Shopify.routes.root}products/${element.node.handle}" class="product-swatches-colors__title">${color}</a>
              </div>`;
      indexer++;
    }
    
    );
    block += restSwatchesItems
      ? restSwatchesContainer.replace(
          /{swatches}/g,
          block + restSwatchesItems
        ).replace(/--moreSwatches--/g,indexer - 3)
      : ``;

    return block;
  }

  function generateAssetsUrl() {
    const currentSwatch = nodeSelectors.container.dataset.currentSwatch;
    const filePath = currentSwatch.split('?');
    const fileName = filePath[0].substring(filePath[0].lastIndexOf('/') + 1);
    const newSwatchUrl = {
      assetsFolder: filePath[0].replace(fileName, ''),
      version: filePath[1],
    };
    return newSwatchUrl;
  }

  /**
   * Set the listeners
   * @param {HTMLElement} container - Swatches container
   */
  function setEventListeners(container) {
    on('mouseover', container, (event) => showColorName(event));
    on('mouseout', container, () => hideColorName());
  }

  /**
   * Show the colour name or remove it.
   * @param {Event} event - Mouseover event.
   */
  function showColorName(event) {
    const color = event.target.dataset.color;
    nodeSelectors.colorName.innerHTML = (color) ? color : '';
  }

  /**
   * Remove the colour name.
   */
  function hideColorName() {
    nodeSelectors.colorName.innerHTML = '';
  }

  /**
   * Initialise component.
   */
  function init() {
    graphQlCall();
    setEventListeners(nodeSelectors.container);
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
